export default __webpack_public_path__ + "static/media/eudelegationV_light.bfd1cbaa.png";